import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';

import * as rootReducer from 'app/core/store';
import * as fromActions from 'app/core/store/actions/auth.actions';
import * as fromAuthSelectors from 'app/core/store/selectors/auth.selectors';
import { PlatformService } from 'app/core/services/platform.service';

@Component({
  standalone: false,
  selector: 'pptl-first-time-user-setup',
  templateUrl: './first-time-user-setup.component.html',
  styleUrls: ['../auth.component.scss', './first-time-user-setup.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FirstTimeUserSetupComponent implements OnInit {
  public verForApproval: boolean;
  public verApproved: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<rootReducer.State>,
    private platformService: PlatformService,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      const userToken = params?.userVerificationCd || '';
     this.store.dispatch(fromActions.VerifyUser({ payload: { userToken } }));
    });
  }

  ngOnInit() {
    this.getVerificationStatus();
  }

  getVerificationStatus() {
    this.store.pipe(select(fromAuthSelectors.getVerificationStatus)).subscribe((res: any) => {
      const verificationMessages = {
        sent: 'Sent For Approval',
        invalid: 'This link is invalid. Re-register again into Promo Portal',
        approved: 'Account has Been Approved',
      };

      if (res === verificationMessages.sent || res === verificationMessages.invalid) {
        this.verForApproval = true;
        this.verApproved = false;
      } else if (res === verificationMessages.approved) {
        this.verForApproval = false;
        this.verApproved = true;
      }
    });
  }

  redirectToLogin() {
    this.router.navigate(['/auth/login'], { replaceUrl: true });
  }

  get isDevicePlatform(): boolean {
    return this.platformService.isCordova();
  }
}
